export const BASELINE_KEY_TO_MODULE: Record<string, string[]> = {
  InventoryManager: ['inventory'],
  WarehouseOperationsManager: ['inventory', 'organization'],
  ProcurementManager: ['procurement'],
  FinanceManager: ['finance'],
  CashierManager: ['finance'],
  CashierEmployee: ['finance'],
  CollectionInstallmentManager: ['installment'],
  SalesCommercialManager: ['sales', 'crm'],
  AgencyManager: ['crm', 'sales'],
  AgencyRepresentative: ['crm', 'sales'],
  AgenciesManager: ['crm', 'sales', 'organization'],
  SalesSupervisor: ['sales', 'crm'],
  LogisticsManager: ['logistics'],
  HqManagement: ['hq'],
  HqTopManagement: ['hq'],
  President: ['hq'],
  GeneralManager: ['hq'],
  WorkshopLeader: ['maintenance'],
  WorkshopTechnician: ['maintenance'],
  WorkshopReceptionist: ['maintenance'],
  WorkshopManager: ['maintenance'],
  WorkshopMaintenanceManager: ['maintenance', 'organization'],
  ChargingStationsManager: ['organization'],
  SystemAdmin: [
    'inventory',
    'procurement',
    'finance',
    'installment',
    'sales',
    'crm',
    'organization',
    'maintenance',
    'hq',
  ],
};

// [pers]
